import { provide, inject } from 'vue';

const checkoutDeliverableStepResetScope: string = 'CheckoutDeliverableStepReset';

export function provideStepReset(callback: () => void): void {
    provide<() => void>(checkoutDeliverableStepResetScope, callback);
}

export function useStepReset(): () => void {
    const reset = inject<void>(checkoutDeliverableStepResetScope);
    if (!reset) {
        throw new Error(`No ${checkoutDeliverableStepResetScope} provided`);
    }
    return reset;
}
